<template>
  <div
    class="qa_accordion tw-px-2"
    :class="{ 'guide-std-margin': noStdMargin }"
  >
    <h1 class="tw-text-center tw-font-bold">Frequently Asked Questions</h1>
    <FaqAccordian
      v-for="(faq, index) in faqs"
      :key="'faq-' + index"
      :title="faq.title"
      :content="faq.content"
    />
  </div>
</template>

<script setup>
import { onMounted, onUnmounted, ref } from 'vue';
import FaqAccordian from './FaqAccordian.vue';

const { initialFaqs } = defineProps({
  initialFaqs: {
    type: Array,
    required: true,
  },

  noStdMargin: {
    type: Boolean,
    default: false,
  },
});

const faqs = ref(initialFaqs);

const fetchFaqs = async (city, area) => {
  try {
    const res = await fetch(
      route('property.faq', {
        city,
        area,
      })
    );

    if (!res.ok) {
      return;
    }

    faqs.value = await res.json();
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('Failed to update FAQs');
  }
};

const onLocationChange = (event) => {
  const { city, area } = event.detail;

  fetchFaqs(city, area);
};

onMounted(() => {
  document.addEventListener('locationChanged', onLocationChange);
});

onUnmounted(() => {
  document.removeEventListener('locationChanged', onLocationChange);
});
</script>
